<template>
    <label class="text-sm block text-cavilam-primary font-semibold" for="profession">
        {{ __('Profession') }}
    </label>
    <select id="profession" v-model="$parent.form.profession"
            :class="{'pointer-events-none opacity-75':readonly}"
            class="w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary"
            :required="required">
        <option :value="null"> -- {{ __('veuillez_selectionner_profession') }} -- </option>
        <option v-for="profession in liste" :value="profession.code">{{ profession.libelle }}</option>
    </select>
    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.profession}">{{ __($parent.form.errors.profession) }}</p>
</template>

<script>
export default {
    name: "ProfessionSelector",
    props: {
        liste: Array,
        required: Boolean,
        readonly: Boolean
    },
}
</script>

<style scoped>

</style>
